import React from 'react';
import { Box, Tab, Tabs, useMediaQuery, useTheme } from '@mui/material';
import { Product } from '../../models/Product';
import { useTranslation } from 'react-i18next';
import ProductConnectedProducts from './connected-products/ProductConnectedProducts';
import useProductIdByHandleSWR from 'hooks/products/useProductIdByHandleSWR';
import { ErrorTypography } from 'components/styled/ErrorTypography';

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Box>{children}</Box>
                </Box>
            )}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export const ProductTabDetails = (props: { product: Product }) => {
    const [value, setValue] = React.useState(0);
    const theme = useTheme();
    const lessThanSmall = useMediaQuery(theme.breakpoints.down('sm'));
    const product = props.product;
    const variant = lessThanSmall ? 'scrollable' : 'standard';
    const { t } = useTranslation('product', {
        keyPrefix: 'PRODUCT.TABS',
    });

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    const { productIdByHandle, isLoading, isError } = useProductIdByHandleSWR(
        product.handle
    );

    if (isError && !isLoading) {
        return <ErrorTypography errorCode={'GLOBAL_ERROR'} />;
    }
    return (
        <>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs
                    centered
                    value={value}
                    onChange={handleChange}
                    aria-label="basic tabs example"
                    variant={variant}
                >
                    <Tab label={t('DESCRIPTION')} {...a11yProps(0)} />
                    <Tab label={t('CONNECTED_PRODUCTS')} {...a11yProps(1)} />
                </Tabs>
            </Box>
            <TabPanel value={value} index={0}>
                <Box
                    dangerouslySetInnerHTML={{
                        __html: product.descriptionHtml,
                    }}
                />
            </TabPanel>
            <TabPanel value={value} index={1}>
                {productIdByHandle && (
                    <ProductConnectedProducts
                        productId={productIdByHandle}
                        collectionHandle={product.collections?.nodes[0]?.handle}
                    />
                )}
            </TabPanel>
        </>
    );
};
